import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { emailsApi } from "../api/client";
import { useEditorStore } from "../editor/store/editorStore";
import { EditorShell } from "../editor/EditorShell";

export function EditorPage() {
    const { id } = useParams<{ id: string }>();
    const load = useEditorStore((s) => s.load);
    const loadedId = useEditorStore((s) => s.emailId);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) return;
        emailsApi
            .get(id)
            .then((email) => load(email.id, email.document, email.version))
            .catch((e) => setError(String(e)));
    }, [id, load]);

    if (error) {
        return (
            <div className="app-shell">
                <main className="main-empty">
                    <p className="status-line error">Could not load email: {error}</p>
                </main>
            </div>
        );
    }
    if (loadedId !== id) {
        return (
            <div className="app-shell">
                <main className="main-empty">
                    <p className="status-line">Loading editor…</p>
                </main>
            </div>
        );
    }
    return <EditorShell />;
}
